import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
  Card,
  CardHeader,
  CardText,
  Avatar,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Loading from "../../Loading";
import FormsyDate from "../../forms/formComponents/FormsyDate";
import formatDate from "../../../../utils/formatDate";

class TeamworkScripts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        dialogCenterStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "90%",
          maxHeight: window.screen.height - 512,
          overflow: "auto",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.runScript = this.runScript.bind(this);
    this.displayIntegrityHours = this.displayIntegrityHours.bind(this);
    this.displayCompanyHours = this.displayCompanyHours.bind(this);
  }

  componentDidMount() {
    if (this.props.location.query.script) {
      if (this.props.location.query.script === "hoursByCompany") {
        let data = {
          startDate: this.props.location.query.startDate || null,
          endDate: this.props.location.query.endDate || null,
        };

        this.runScript(
          "/api/scripts/getCompanyHours",
          {},
          this.displayCompanyHours,
        );
      }
    }
  }

  runScript(endpoint, data, displayFunction) {
    console.log(endpoint, data);
    let url = endpoint;
    let options = {
      method: "post",
      headers: {
        Accept: "application/json",
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        displayFunction(json);
      });
  }

  displayIntegrityHours(data) {
    let { dialogCenterStyle } = this.state.styles;
    let title = `Integrity Implants Actual Hours per Week`;

    let content = [
      <div key="display" className="container" style={dialogCenterStyle}>
        {Object.keys(data).map((key) => {
          return (
            <Card key={key} zDepth={1}>
              <CardHeader
                title={`${data[key].start} to ${data[key].end}`}
                titleStyle={{ fontSize: "125%" }}
                // actAsExpander={true}
                // showExpandableButton={true}
                avatar={
                  <Avatar color="#212121" backgroundColor="#FFFFFF">
                    <span style={{ fontSize: "75%" }}>
                      {data[key].hours.toFixed(2)}
                    </span>
                  </Avatar>
                }
              />
            </Card>
          );
        })}
      </div>,
    ];

    let actions = [
      <FlatButton
        key="ok"
        label="Ok"
        onClick={this.props.closeDialog.bind(this)}
      />,
    ];

    this.props.openDialog(title, content, actions);
  }

  displayCompanyHours(response) {
    let { dialogCenterStyle } = this.state.styles;
    let companies = response.data;
    let query = response.query;
    let title = `Actual Hours by Company ${formatDate(new Date(query.startDate))} - ${formatDate(new Date(query.endDate))}`;

    let content = [
      <div key="display" className="container" style={dialogCenterStyle}>
        {Object.keys(companies).map((key) => {
          let employees = Object.keys(companies[key].employees).map(
            (empKey) => {
              return (
                <div key={empKey}>
                  <div className="col-sm-2">
                    {companies[key].employees[empKey].actual.toFixed(2)}
                  </div>
                  <div className="col-sm-10">
                    {companies[key].employees[empKey].name}
                  </div>
                </div>
              );
            },
          );
          return (
            <Card key={key} zDepth={1}>
              <CardHeader
                title={companies[key].name}
                titleStyle={{ fontSize: "125%" }}
                actAsExpander={true}
                showExpandableButton={true}
                avatar={
                  <Avatar color="#212121" backgroundColor="#FFFFFF">
                    <span style={{ fontSize: "75%" }}>
                      {companies[key].actual.toFixed(2)}
                    </span>
                  </Avatar>
                }
              />
              <CardText expandable={true}>
                <div
                  className="container"
                  style={{ paddingLeft: "1em", width: "75%" }}
                >
                  {employees}
                </div>
              </CardText>
            </Card>
          );
        })}
      </div>,
    ];

    let actions = [
      <FlatButton
        key="ok"
        label="Ok"
        onClick={this.props.closeDialog.bind(this)}
      />,
    ];

    this.props.openDialog(title, content, actions);
  }

  notifyFormError(data) {
    alert("Missing Data: check that all fields are filled");
    console.error("Form error:", data);
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle } = this.state.styles;

      return (
        <div>
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <Card
              zDepth={2}
              style={{ backgroundColor: "#5C6BC0", marginTop: "0.45em" }}
            >
              <CardHeader
                title="Integrity Implants Hours"
                titleStyle={{ fontWeight: "bold", fontSize: "150%" }}
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText
                expandable={true}
                style={{ backgroundColor: "#FAFAFA", margin: "0.5em" }}
              >
                <Formsy.Form
                  ref="integrityImplantsHours"
                  onValidSubmit={(data) =>
                    this.runScript(
                      "/api/scripts/getIntegrityHours",
                      data,
                      this.displayIntegrityHours,
                    )
                  }
                  onInvalidSubmit={this.notifyFormError}
                >
                  <Subheader>Date Range</Subheader>
                  <div style={centerStyle}>
                    <FormsyDate
                      name="startDate"
                      required
                      fullWidth={true}
                      firstDayOfWeek={0}
                      formatDate={(date) => formatDate(date)}
                      floatingLabelText="Start Date"
                    />
                    <FormsyDate
                      name="endDate"
                      required
                      fullWidth={true}
                      firstDayOfWeek={0}
                      formatDate={(date) => formatDate(date)}
                      floatingLabelText="End Date"
                    />
                  </div>
                  <Divider />
                  <div style={centerStyle}>
                    <FlatButton
                      backgroundColor="#A5D6A7"
                      hoverColor="#81C784"
                      style={{ marginTop: "2em" }}
                      label="Run"
                      type="submit"
                    />
                  </div>
                </Formsy.Form>
              </CardText>
            </Card>
            <br />
            <Card
              zDepth={2}
              style={{ backgroundColor: "#5C6BC0", marginTop: "0.45em" }}
            >
              <CardHeader
                title="Actual Hours by Company"
                titleStyle={{ fontWeight: "bold", fontSize: "150%" }}
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText
                expandable={true}
                style={{ backgroundColor: "#FAFAFA", margin: "0.5em" }}
              >
                <Formsy.Form
                  ref="hoursByCompany"
                  onValidSubmit={(data) =>
                    this.runScript(
                      "/api/scripts/getCompanyHours",
                      data,
                      this.displayCompanyHours,
                    )
                  }
                  onInvalidSubmit={this.notifyFormError}
                >
                  <Subheader>Date Range</Subheader>
                  <div style={centerStyle}>
                    <FormsyDate
                      name="startDate"
                      required
                      fullWidth={true}
                      firstDayOfWeek={0}
                      formatDate={(date) => formatDate(date)}
                      floatingLabelText="Start Date"
                    />
                    <FormsyDate
                      name="endDate"
                      required
                      fullWidth={true}
                      firstDayOfWeek={0}
                      formatDate={(date) => formatDate(date)}
                      floatingLabelText="End Date"
                    />
                  </div>
                  <Divider />
                  <div style={centerStyle}>
                    <FlatButton
                      backgroundColor="#A5D6A7"
                      hoverColor="#81C784"
                      style={{ marginTop: "2em" }}
                      label="Run"
                      type="submit"
                    />
                  </div>
                </Formsy.Form>
              </CardText>
            </Card>
          </Paper>
        </div>
      );
    }
  }
}

export default TeamworkScripts;



// WEBPACK FOOTER //
// ./app/components/teamwork/scripts/TeamworkScripts.js